module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xfQEEk/tc-custom/9781488083587.jpg?1725275550992",
      "alt": "This image is the cover for the book Sheikh's Baby of Revenge"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sheikh's Baby of Revenge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A vengeful seduction. A woman—and an heir—he must possess. First in the series of four royal brothers and the women who match their fiery passions.")]), _c('br'), _c('br'), _vm._v("Seeking revenge for his royal family’s rejection, warrior sheikh Adir seduces his brother’s innocent fiancée! But when he returns to steal Amira from the altar, he discovers their illicit encounter left her pregnant. Secluded in the desert, longing soon consumes them. But Adir’s baby must be legitimate—and he’ll claim his with a vow . . ."), _c('br'), _c('br'), _vm._v("“Interesting and emotionally-charged . . . had me hooked from the very beginning . . . I would recommend "), _c('i', [_vm._v("Sheikh’s Baby of Revenge")]), _vm._v(" by Tara Pammi, if you enjoy revenge trope, the enemy to lovers trope or books by authors Lynne Graham, Michelle Smart, Chantelle Shaw and Cathy Williams.” —"), _c('i', [_vm._v("Harlequin Junkiei")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tara Pammi\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tara Pammi can't remember a moment when she wasn't lost in a book, especially a romance which, as a teenager, was much more exciting than mathematics textbook. Years later Tara’s wild imagination and love for the written word revealed what she really wanted to do: write! She lives in Colorado with the most co-operative man on the planet and two daughters. Tara loves to hear from readers and can be reached at tara.pammi@gmail.com or her website www.tarapammi.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0